import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Card} from 'react-bootstrap';
import axios from 'axios';
import {useEffect, useState} from 'react';


let baseURL = "https://api.themoviedb.org/3/trending/movie/week?api_key=";
let apiKey = "aed346e7e561872b9429ec2a49a62170";

let imgURL = "https://image.tmdb.org/t/p/w200/";

let requestURL = baseURL + apiKey;
console.log(requestURL);


function TrendingMovies() {

    const [trendingMovies, setTrendingMovies] = useState([]);

    const getTrendingMovies = () => {
        axios.get(requestURL)
        .then(function (response) {
            console.log(response)
            for (let i = 0; i < 11; i++) {
                console.log(response.data.results[i].title);
                setTrendingMovies(trendingMovies => [...trendingMovies, <div key={i} className="trendingMovies">
                <Card style={{ width: '14rem', margin: '10px', borderRadius: '5px', border: '1px solid rgba(0,0,0,.125)'}}>
                <Card.Img variant="top" src={imgURL + response.data.results[i].poster_path} />
                <Card.Body style={{height:"6rem", overflow:"hidden"}}>
                    <Card.Title>{response.data.results[i].title}</Card.Title>
                </Card.Body>
                </Card></div>])
            }
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
        }); 
    }

    useEffect(() => {
        getTrendingMovies();
    }, []);
    
    return (
        <div className="containerTrending">{trendingMovies}</div>
    );
}

export default TrendingMovies;